import { render, staticRenderFns } from "./FreePatientOrderAddPage.vue?vue&type=template&id=a49574ca&scoped=true"
import script from "./FreePatientOrderAddPage.vue?vue&type=script&lang=js"
export * from "./FreePatientOrderAddPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49574ca",
  null
  
)

export default component.exports